import { useState, useEffect } from "react";
import { axiosCarvenui } from "../../util/integration";

export const useCarData = ({
  selectedBrands,
  selectedEngineCapacities,
  selectedFuelTypes,
  selectedShapes,
  selectedTransmissions,
  selectedModels,
  maxPrice,
  minPrice,
  maxYear,
  minYear,
  brand,
  shape,
}) => {
  const [groupedCars, setGroupedCars] = useState([]);
  const [loading, setLoading] = useState(false);

  const prepareGroupedCarsWithYear = (resData) => {
    const brandDict = {};
    const modelDict = {};

    resData.forEach((item) => {
      const brandName = item.car.model.brand.name;
      const brandNameAr = item.car.model.brand.name_ar;
      const modelName = item.car.model.name;
      const modelNameAr = item.car.model.name_ar;
      brandDict[brandName] = brandNameAr;
      modelDict[modelName] = modelNameAr;
    });

    let result = resData.reduce(function (rv, x) {
      let keyToGroup = x["car"]["model"]["brand"]["name"];
      (rv[keyToGroup] = rv[keyToGroup] || []).push(x);
      return rv;
    }, {});

    let arr = [];
    for (let key in result) {
      let b_result = (result[key] = result[key].reduce(function (rv, x) {
        let keyToGroup = x["car"]["model"]["name"];
        (rv[keyToGroup] = rv[keyToGroup] || []).push(x);
        return rv;
      }, {}));

      let models = Object.keys(b_result).map((modelKey) => {
        let m_result = b_result[modelKey].reduce(function (rv, x) {
          let keyToGroup = x["car"]["year"];
          (rv[keyToGroup] = rv[keyToGroup] || []).push(x);
          return rv;
        }, {});

        return Object.keys(m_result).map((mk) => ({
          model_name: modelKey,
          model_name_ar: modelDict[modelKey],
          cars: m_result[mk],
        }));
      });

      arr.push({
        brand_name: key,
        brand_name_ar: brandDict[key],
        models: models.reduce((a, b) => a.concat(b), []),
      });
    }

    return arr;
  };

  const buildFilterQuery = () => {
    let query = "/car_detail/?";

    if (selectedBrands.size > 0) {
      query += `&car__model__brand__in=${[...selectedBrands]
        .map((b) => b?.id)
        .join(",")}`;
    }

    if (selectedModels.size > 0) {
      query += `&car__model__in=${[...selectedModels]
        .map((m) => m.id)
        .join(",")}`;
    }

    if (selectedFuelTypes.size > 0) {
      query += `&car__fuel_type__in=${[...selectedFuelTypes].join(",")}`;
    }

    if (selectedShapes.size > 0) {
      query += `&car__body_type__in=${[...selectedShapes].join(",")}`;
    }

    if (selectedTransmissions.size > 0) {
      query += `&car__transmission__in=${[...selectedTransmissions].join(",")}`;
    }

    if (selectedEngineCapacities.size > 0) {
      query += `&car__engine__in=${[...selectedEngineCapacities].join(",")}`;
    }

    if (maxPrice && minPrice) {
      query += `&car_price__gte=${minPrice}&car_price__lte=${maxPrice}`;
    }

    if (maxYear && minYear) {
      query += `&car__year__gte=${minYear}&car__year__lte=${maxYear}`;
    }

    return query;
  };

  const handleFilter = async () => {
    try {
      setLoading(true);
      const query = buildFilterQuery();
      const res = await axiosCarvenui.get(query);

      if (res?.data?.results) {
        let cars = prepareGroupedCarsWithYear(res.data.results);
        setGroupedCars(cars);
      }
    } catch (error) {
      console.error("Error filtering cars:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const getCars = async () => {
      try {
        setLoading(true);
        const res = await axiosCarvenui.get("car_detail/");

        if (res?.data?.results) {
          let cars = prepareGroupedCarsWithYear(res.data.results);
          setGroupedCars(cars);
        }
      } catch (error) {
        console.error("Error fetching cars:", error);
      } finally {
        setLoading(false);
      }
    };

    if (brand === undefined && shape === undefined) {
      getCars();
    }
  }, [brand, shape]);

  return {
    groupedCars,
    loading,
    handleFilter,
  };
};
